module.exports = __webpack_public_path__ + "static/media/dua-lipa-lose.0f73063c.jpg";